// Canonical project accent colors. The dashboard's chart palette plus a
// couple of semantic tokens so the color picker stays in sync with the
// rest of the design system.
//
// SUGGESTED_COLORS is rendered as the swatch row on the new project page
// and the edit project modal. The values are CSS custom properties
// (defined in style.css) so dark mode flips automatically.
export const SUGGESTED_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "var(--info)",
  "var(--success)",
] as const;

export type SuggestedColor = (typeof SUGGESTED_COLORS)[number];
